import { IObservable, Observable } from '@1js/oil-externals/rx';
import { SearchResultType } from '../search-instrumentation.service';
import { BaseSuggestionProvider } from './base.search-suggestion-provider';

/*
 * Data provider for more result.
 */
export class TemplateSuggestionProvider extends BaseSuggestionProvider {

    public static buttonText: (matchedTemplate: string) => string;
    public static seeMoreButtonText: (searchText: string) => string;
    private static readonly MIN_NUM_OF_CHARS: number = 3;
    private static readonly languagePrefix = 'en';
    private static readonly templateURL: string = 'https://templates.office.com/en-US/Search/results?query=';
    private static readonly templatePlatform: string = '&platform=Wac';
    private static readonly topTemplateSearchTexts: Array<string> = ['resume',
        'cover letter',
        'CV',
        'gantt', // Chart
        'calendar',
        'budget',
        'menu',
        'brochure',
        'presentation',
        'flyer',
        'invoice',
        'paper',
        'report',
        'timeline',
        'planner',
        'tracker',
        'certificate',
        'newsletter',
        'schedule',
        'card',
        'business card',
        'agenda',
        'label',
        'photo album',
        'business plan',
        'curriculum',
        'letter'];

    public static getTemplateURL(matchedTemplate: string) {
        return TemplateSuggestionProvider.templateURL + matchedTemplate + TemplateSuggestionProvider.templatePlatform;
    }

    public createStream(searchText: string): IObservable<any> {

        const templates: Array<object> = [];
        const renderedResults: Array<string> = [];

        if (TemplateSuggestionProvider.contextService.sharedContext.officeMarket.indexOf(TemplateSuggestionProvider.languagePrefix) === 0 &&
            (searchText.length >= TemplateSuggestionProvider.MIN_NUM_OF_CHARS || searchText.toLowerCase() === 'cv')) {
            let id: number = 1;
            const lcSearchText: string = searchText.toLowerCase();
            TemplateSuggestionProvider.topTemplateSearchTexts.forEach(template => {
                const text: string = template.toLowerCase();
                if (text.indexOf(lcSearchText) === 0 || lcSearchText.indexOf(text) === 0 ) {
                    const matchedTemplate: string = template.replace(/\w\S*/g, w => (w.replace(/^\w/, c => c.toUpperCase())));
                    templates.push({
                        id: (id++).toString(),
                        isPwa: TemplateSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                        isDarkMode: TemplateSuggestionProvider.isDarkMode,
                        urlToOpen: TemplateSuggestionProvider.getTemplateURL(matchedTemplate),
                        title: TemplateSuggestionProvider.buttonText(matchedTemplate),
                        matchedTemplate,
                        searchInstrumentationService: TemplateSuggestionProvider.searchInstrumentationService,
                        urlLauncherService: TemplateSuggestionProvider.urlLauncherService
                    });
                    renderedResults.push(matchedTemplate);
                }
            });
        }

        TemplateSuggestionProvider.searchInstrumentationService.setRenderedProviderResults(SearchResultType.Template, renderedResults);
        return Observable.fromArray(templates);
    }

    public getId(): string {
        return 'template';
    }
}
